import React, {useEffect, useState} from "react";
import general from "../../../general";
import {Link} from "react-router-dom";
import moment from "moment";
import $ from "jquery";
import {PlayCircleOutlined} from '@ant-design/icons';
import {useScroll} from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import {NavLink} from "../../../lib/Navigation";
import useActiveState from "../../../lib/useActiveState";
import Subtitle from "../../components/Subtitle";
import { useHistory } from "react-router-dom";
import GameTags from "../../components/game/GameTags";

export default props => {
  
  const [agent] = useActiveState('agent');
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const [user] = useActiveState('user');
  const [randomColorInfo] = useActiveState('randomColorInfo');
  const history = useHistory()

  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    if (!init) {
      Dialog.loading();
    }
    let tmp = {
      type: 3,
      game_species_type: props.type,
      pagination: {page: page},
    };
    if (parms.page) {
      tmp.pagination = {page: parms.page};
    }
    general.axios.post('/reserveGames', tmp)
        .finally(() => {
          setLoading(false);
          Dialog.close();
          parms.finishPullUp && parms.finishPullUp();
          parms.finishPullDown && parms.finishPullDown();
        })
        .then(response => {
          setInit(true);
          let result = response.data.data;
          if (parms.page) {
            setPage(parms.page);
          }
          result.game_list.forEach(d => {
            d.infoColor = randomColorInfo[parseInt(Math.random() * 4)]
          })
          setGames(games => parms.page === 1 || !parms.page ? result.game_list : [...games, ...result.game_list]);
          setMore(result.paginated.more);
        })
        .catch(err => {
          Dialog.error(err.message);
        });
  }
  useEffect(() => {
    if (props.active && !init) {
      load();
    }
  }, [props.active,init]);

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && init) {
      if (scroll.top < -80) {
        load({page: 1});
      }
      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        load({page: page + 1});
      }
    }
  }, [scroll, props.active]);

  //新游游戏点击埋点
  const clickGameOfTheNewGame = (game) => {
    
  }

  const reserve = (game) => {    
    if (!user.mobile){
      history.push('/user/phone');
      return
    }
    general.axios.post(game.is_reserved ? '/cancelReserveGame' : '/reserveGame', {id: game.maiyou_gameid})
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let result = res.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
        } else {
          let message = game.is_reserved ? '取消成功' : '预约成功';
          Dialog.success(message);
          const newGame = games.filter(item =>{
            if (item.maiyou_gameid == game.maiyou_gameid){
              item.is_reserved = !item.is_reserved;
            }
            return item.maiyou_gameid == game.maiyou_gameid;
          })
          console.log(newGame);
          setGames([...games],[...newGame])
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  };

  return <div className="new-reserve">
    {games.map(game => <div className="new-reserve-item">
      <Link to={'/game?id=' + game.game_id + '&agent='+agent} className="subject" onClick={()=>clickGameOfTheNewGame(game)}>
        <div className="icon">
          <Image src={game.game_image.thumb}/>
        </div>
        <div className="text">
          <div className="name">
            <div className={"named " + (game.nameRemark ? " name-new" : "")}>{game.game_name}</div>
            {/* <div className="date">{moment(game.starting_time * 1000).format('MM-DD HH:mm')}首发</div> */}
            <div className="date">{game.label}</div>
          </div>
          <div className="info1">
            {game.game_classify_type.trim()}
            <Subtitle>{game.nameRemark}</Subtitle>
            {/* <div className="reserve">{game.reserved_total}人预约</div> */}
            {/* <div className="date">{moment(game.starting_time * 1000).format('MM-DD HH:mm')}首发</div> */}
          </div>
          <GameTags game={game}></GameTags>
        </div>
        
        <NavLink user={true} className={"btn " + (game.is_reserved || game.first_open_pending == 1 ? 'disable' : '')} onClick={e=>{
          if (game.is_reserved || game.first_open_pending == 1){
            return
          }
          e.preventDefault()
          e.stopPropagation()
          reserve(game)
        }}>{game.is_reserved ? "已预约" : (game.first_open_pending == 1 ? '时间待定' : '预约')}</NavLink>
      </Link>
      <div className="medias clearfix">
        <Link to={'/video?url=' + game.video_url} className="media">
          <div className="container" style={{height:'100%'}}>
            <Image src={game.game_ursmall_list[0]} alt=""/>
            <PlayCircleOutlined className="play"/>
          </div>
        </Link>
        {[game.game_ursmall_list[1],game.game_ursmall_list[2],game.game_ursmall_list[3],game.game_ursmall_list[4]].map((img, index, imgs) => img ? <Link className="media" to={'/img?imgs=' + game.game_ur_list[index] + '&img=' + index}>
          <Image src={img} alt=""/>
        </Link> : null)}
      </div>
    </div>)}
    {/* <NavLink to="/new/reserved" className="new-reserve-my-reserved">
      <span>我的预约</span>
    </NavLink> */}
    {games.length > 3 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
  </div>;
};